import cn from 'classnames';
import React from 'react';

import styles from './Grid.module.scss';

export type ColProps = Pick<
  React.HTMLProps<HTMLDivElement>,
  'children' | 'className' | 'style'
>;

const Col: React.FC<ColProps> = ({ children, className, style }) => (
  <div className={cn(styles.col, className)} {...{ style }}>
    {children}
  </div>
);

export default Col;
